import React, {
  useRef,
  useEffect,
  useState,
  useReducer,
  useContext,
} from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, FormElement } from "@progress/kendo-react-form";
import "./dialog-sign.css";
import CanvasDraw from "@win11react/react-canvas-draw";
import P5Contianer from "./P5Contianer";
import { useMediaQuery } from "@material-ui/core";
import { Context } from "../../../Context";
import { PDFDocument } from "pdf-lib";
import { pdfjs } from "react-pdf";
import { getStampTimeAndTimezone } from "../../../utils";

const gotToEnd = () => {
  let out = document.getElementsByClassName("k-dialog-content");
  out[0].scrollTop = out[0].scrollHeight * 0.7;
};

const saveImage = (activeStroke = false) => {
  let sourceCanvas = document.getElementsByTagName("canvas")[1];
  let destinationCanvas = document.createElement("canvas");
  destinationCanvas.height = sourceCanvas.height;
  destinationCanvas.width = sourceCanvas.width;
  let destinationContext = destinationCanvas.getContext("2d");
  if (activeStroke) {
    destinationContext.strokeStyle = "#427FBA";
    destinationContext.lineWidth = 5;
    destinationContext.strokeRect(
      0,
      0,
      sourceCanvas.width,
      sourceCanvas.height
    );
  }
  destinationContext.drawImage(sourceCanvas, 0, 0);
  destinationContext.globalCompositeOperation = "destination-over";
  destinationContext.fillStyle = "#4484a500";
  destinationContext.fillRect(
    0,
    0,
    destinationCanvas.width,
    destinationCanvas.height
  );
  let image = destinationCanvas.toDataURL("image/png");
  return {
    newImg: image,
    imageWidth: destinationCanvas.width,
    imageHeight: destinationCanvas.height,
  };
};

function setTextInCanvas(x, y, text) {
  try {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    let ctx = sourceCanvas.getContext("2d");
    ctx.font = "bold 25px Arial";
    ctx.textAlign = "center";
    ctx.fillText(text, sourceCanvas.width / 2, y);
  } catch (error) { }
}

function setNamesInCanvas(firstName, lastName) {
  if (firstName.length + lastName.length > 26) {
    setTextInCanvas(0, 205, `${firstName}`)
    setTextInCanvas(0, 235, `${lastName}`)
  } else {
    setTextInCanvas(0, 235, `${firstName} ${lastName}`)
  }
}

const initialValuesState = {
  activeOnSubit: false,
  signatureData: {},
};

function valuesReducerActions(state, action) {
  switch (action.type) {
    case "setActiveOnSubit":
      return { ...state, activeOnSubit: action.data };
    default:
      throw new Error();
  }
}

const DialogAcceptMultiSignatureAutografaCustom = (props) => {
  const { toggleDialogAccept, visibleAccept } = props;

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [pagesSize, setPagesSize] = useState([]);
  const [numPages, setNumPages] = useState(null);
  const [tempImgPages, setTempImgPages] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [pager, setPager] = useState(1);
  const { setCanvasData, setShowSignatureCanvas } = useContext(Context);
  const [currentSystem, setCurrentSystem] = useState("");
  const { t } = useTranslation();
  const pad = useRef(null);
  const [date, setDate] = useState("");
  const [signatureImgeData, setSignatureImgeData] = useState(null);
  const [propsImgSignature, setPropsImgSignature] = useState(null);
  const [step, setStep] = useState("sign");
  const [imgSignature, setImgSignature] = useState(null);
  const [widthImgSignature, setWidthImgSignature] = useState(400);
  const [heightImgSignature, setHeightImgSignature] = useState(300);
  const [pagesImgs, setPagesImgs] = useState([]);

  const [startImg, setStartImg] = useState(null);
  const [values, dispatchValues] = useReducer(
    valuesReducerActions,
    initialValuesState
  );

  const [clicAvailable, setClicAvailable] = useState(false);

  let greyText =
    step === "sign"
      ? "dialogAcceptSignature.noticeCreateSignAutografa"
      : "dialogAcceptSignature.noticeCreateSignAutografaCustom";

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");
  const isTouchScreendevice = () =>
    "ontouchstart" in window || navigator.maxTouchPoints;
  if (isTouchScreendevice()) isMobile = true;

  useEffect(() => {
    setNumPages(props.numPages);
    setPageNumber(props.pageNumber);
    setPager(props.pager);
    setTempImgPages(props.tempImgPages);
  }, [props.numPages, props.pageNumber, props.pager, props.tempImgPages]);
  useEffect(() => {
    if (props.signRequestPDF) getPdgPageSize();
  }, [props.signRequestPDF]);

  const getPdgPageSize = async () => {
    const pdfDoc = await PDFDocument.load(pdfFile);
    const pages = pdfDoc.getPages()
    let sizes = pages.map((i) => i.getSize());
    setPagesSize(sizes);
  };
  let pdfFile =
    "data:application/pdf;filename=file.pdf;base64," + props.signRequestPDF;

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
    setPager((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    if (pageNumber <= 1) return;
    changePage(-1);
  };

  const nextPage = () => {
    if (pageNumber >= numPages) return;
    changePage(1);
  };

  useEffect(() => {
    let tempArr = [...Array(numPages)];
    for (const key in tempImgPages) {
      tempArr[Number(key)] = tempImgPages[key];
    }
    setPagesImgs(tempArr);
  }, [tempImgPages]);

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  useEffect(() => {
    if (
      visibleAccept &&
      !props?.showLoadingRequesting &&
      props?.currentSignaturetype.id ===
      Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) &&
      step === "sign"
    ) {
      setTimeout(() => {
        setNamesInCanvas(
          props.tokenUserNames, props.tokenUserLastnames
        );
      }, 100);
    }
  }, [visibleAccept, step]);

  const isPhone = useMediaQuery("(max-width:500px)");

  if (isMobile)
    greyText = "dialogAcceptSignature.noticeCreateSignAutografaMobile";

  return (
    <Dialog
      title={t("dialogAcceptSignature.titleAcceptSignRequest", {
        signatureType: props.currentSignaturetype.name,
      })}
      className="dialog-signature"
      onClose={toggleDialogAccept}
    >
      <div
        style={{
          width: "100%",
          height: "auto",
          backgroundColor: "#DEDEDE",
          position: "sticky",
          top: "0",
          zIndex: "1",
        }}
      >
        <div style={{ padding: "10px", fontWeight: "500" }}>
          <p
            style={{
              margin: "0px",
              fontFamily: "Quicksand",
              lineheight: "1.4",
              paddingBottom: "10px",
            }}
          >
            {t(greyText)}
          </p>{" "}
          {greyText ===
            "dialogAcceptSignature.noticeCreateSignAutografa" && (
              <p
                style={{
                  margin: "0px",
                  fontFamily: "Quicksand",
                  lineheight: "1.4",
                }}
              >
                {t("dialogAcceptSignature.noticeCreateSignAutografa2")}
              </p>
            )}
        </div>
      </div>
      <div>
        <Form
          style={{ margin: "0px" }}
          onSubmit={() => { }}
          allowSubmit={true}
          className="formCustomSignature"
          valid={true}
          touched={true}
          visited={true}
          render={() => {
            let disabled = false;
            return (
              <FormElement
                style={{
                  maxWidth: "450px !important",
                  width: "100%",
                  margin: "auto",
                }}
              >
                <div>
                  {step === "sign" && (
                    <>
                      <div
                        className={`button-dialog-accept button-dialog-accept-size`}
                      >
                        <span
                          className="one-more-signature"
                          onClick={() => {
                            setClicAvailable(false)
                            setPropsImgSignature(null);
                            pad.current.clear();
                            setTimeout(() => {
                              setNamesInCanvas(
                                props.tokenUserNames, props.tokenUserLastnames
                              );
                            }, 0);
                            setTimeout(
                              () => setPropsImgSignature(saveImage()),
                              10
                            );
                          }}
                        >
                          {"Limpiar"}
                        </span>
                      </div>
                      <div className={"canvas-draw"}>
                        <CanvasDraw
                          ref={pad}
                          loadTimeOffset={0}
                          lazyRadius={2}
                          brushRadius={2}
                          brushColor={"#000"}
                          catenaryColor={"#0a0302"}
                          gridColor={"rgba(150,150,150,0.17)"}
                          hideGrid={true}
                          canvasWidth={"95%"}
                          canvasHeight={300}
                          disabled={false}
                          immediateLoading={true}
                          hideInterface={false}
                          onChange={(e) => {
                            setClicAvailable(true)
                          }
                          }
                        />
                      </div>
                    </>
                  )}
                  {step === "location" && (
                    <div
                      style={{
                        width: pagesSize[0].width + 16,
                        height: pagesSize[0].height + 16,
                      }}
                    >
                      <div
                        className={`button-dialog-accept button-dialog-accept-size icons-bars`}
                      >
                        <span
                          class="k-icon k-i-arrow-double-60-left icon-bar"
                          onClick={() => {
                            setPageNumber(1);
                            setPager(1);
                          }}
                        ></span>
                        <span
                          class="k-icon k-i-arrow-60-left icon-bar"
                          onClick={previousPage}
                        ></span>
                        <div
                          className="pagec"
                          style={{
                            color: "#427FBA",
                            textAlign: "center",
                            fontWeight: "bold",
                            marginTop: "auto",
                            marginBottom: "auto",
                            padding: '0px 5px'
                          }}
                        >
                          Página
                          <input
                            style={{
                              width: "32px",
                              marginLeft: "4px",
                              marginRight: "3px",
                            }}
                            type="text"
                            value={pager}
                            onChange={({ target }) => {
                              setPager(Number(target.value));
                              if (Number(target.value) <= numPages) {
                                if (Number(target.value) <= 0) {
                                  setPageNumber(1);
                                  setPager(1);
                                } else
                                  setPageNumber(Number(target.value));
                              } else
                                setTimeout(() => {
                                  setPager(pageNumber);
                                }, 1000);
                            }}
                          />
                          de {numPages || "--"}
                        </div>
                        <span
                          class="k-icon k-i-arrow-60-right icon-bar"
                          onClick={nextPage}
                        ></span>
                        <span
                          class="k-icon k-i-arrow-double-60-right icon-bar"
                          onClick={() => {
                            setPageNumber(numPages);
                            setPager(numPages);
                          }}
                        ></span>
                      </div>
                      {pagesImgs.map((item, index) => (
                        <React.Fragment key={String(index)}>
                          <div
                            style={
                              index === pageNumber - 1
                                ? {}
                                : { display: "none" }
                            }
                          >
                            <P5Contianer
                              base64Img={item}
                              widthImg={pagesSize[index].width}
                              heightImg={pagesSize[index].height}
                              imgSignature={imgSignature}
                              widthImgSignature={widthImgSignature}
                              heightImgSignature={heightImgSignature}
                              signatures={props.signatures}
                              currentPage={index + 1}
                              pageNumber={index}
                              save={async (params) => {
                                let temp = {
                                  ...params,
                                  page: index + 1,
                                };
                                let { signatures, dataItem } = props;
                                let fileSignImage = null;
                                await fetch(
                                  propsImgSignature.imgSignature
                                )
                                  .then((res) => res.blob())
                                  .then((blob) => {
                                    const file = new File(
                                      [blob],
                                      "signature.png"
                                    );
                                    fileSignImage = file;
                                  });
                                signatures = signatures.map((i) =>
                                  i.index === dataItem.index
                                    ? {
                                      ...dataItem,
                                      date,
                                      ...signatureImgeData,
                                      ...temp,
                                      ...propsImgSignature,
                                      fileSignImage,
                                    }
                                    : i
                                );
                                props.setSignatures(signatures);
                                toggleDialogAccept();
                              }}
                              activeOnSubit={values.activeOnSubit}
                              signatureData={values.signatureData}
                              dispatchValues={dispatchValues}
                              back={() => {
                                setStep("sign")
                                setClicAvailable(false)
                              }}
                              cancel={() => {
                                setStep("sign")
                                setClicAvailable(false)
                              }}
                              isMobile={false}
                              gotToEnd={gotToEnd}
                              isPhone={isPhone}
                            />
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  )}
                  {step === "sign" && (
                    <div
                      className={`button-dialog-accept button-dialog-accept-size ${step === "location" &&
                        "button-on-custom-signature"
                        }`}
                    >
                      <div className="btn-conttainer">
                        <button
                          className={"canvasCancelBtn"}
                          type="submit"
                          onClick={toggleDialogAccept}
                        >
                          {"Cerrar"}
                        </button>
                        <button
                          className={"canvasBtn"}
                          type="submit"
                          onClick={async () => {
                            const stampTime = await getStampTimeAndTimezone()
                            if (stampTime === false) props.onErrorTimeStamp()
                            setTextInCanvas(
                              100,
                              265,
                              `${stampTime}`
                            );
                            setTimeout(() => {
                              let {
                                newImg,
                                imageWidth,
                                imageHeight,
                              } = saveImage();
                              setImgSignature(newImg);
                              if (isMobile) {
                                let imgSignatureStroke =
                                  saveImage(true);
                                let imgSignature = saveImage();
                                setCanvasData({
                                  imgSignature:
                                    imgSignatureStroke.newImg,
                                  pagesImgs,
                                  numPages,
                                  pagesSize,
                                  pager,
                                  newImg: imgSignature.newImg,
                                  dataItem: props.dataItem,
                                  signatures: props.signatures,
                                  pageNumber,
                                  greyText: t(
                                    "dialogAcceptSignature.noticeCreateSignAutografaCustomMobile"
                                  ),
                                  widthImgSignature,
                                  heightImgSignature,
                                  page: pageNumber,
                                  back: () => {
                                    setTimeout(() => {
                                      toggleDialogAccept();
                                    }, 100);
                                  },
                                  save: async (params) => {
                                    props.setCurrentIndex(null);

                                    let temp = { ...params };
                                    let { signatures, dataItem } =
                                      props;
                                    let fileSignImage = null;
                                    await fetch(imgSignature.newImg)
                                      .then((res) => res.blob())
                                      .then((blob) => {
                                        const file = new File(
                                          [blob],
                                          "signature.png"
                                        );
                                        fileSignImage = file;
                                      });
                                    signatures = signatures.map((i) =>
                                      i.index === dataItem.index
                                        ? {
                                          ...dataItem,
                                          date,
                                          ...signatureImgeData,
                                          ...temp,
                                          ...propsImgSignature,
                                          fileSignImage,
                                          imgSignature:
                                            imgSignature.newImg,
                                        }
                                        : i
                                    );

                                    if (isMobile) {
                                      props.setCurrentPage(0);
                                      props.setCurrentPage(
                                        params.page
                                      );
                                    }

                                    props.setSignatures(signatures);

                                    setStep("sign");
                                    setSignatureImgeData({
                                      ...params,
                                    });
                                    toggleDialogAccept();
                                    setShowSignatureCanvas(false);
                                  },
                                });
                              }
                              setPropsImgSignature({
                                imgSignature: newImg,
                                imageWidth,
                                imageHeight,
                              });
                              setWidthImgSignature(imageWidth);
                              setHeightImgSignature(imageHeight);
                              if (isMobile) {
                                setTimeout(() => {
                                  setShowSignatureCanvas(true);
                                }, 200);
                              } else {
                                setStep("location");
                              }
                            }, 0);
                          }}
                          disabled={!clicAvailable}
                        >
                          {"Capturar Firma"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </FormElement>
            );
          }}
        />
      </div>
    </Dialog>
  );
};

export { DialogAcceptMultiSignatureAutografaCustom as default };
